import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    font-size: 16px;
    font-weight: 500; 
    display: flex;
    justify-content: space-between;
    padding: 6px;
    /* padding-bottom: 6px; */
    color: #1890ff;
    border-bottom: 1px solid #eee;
    margin-bottom: 2px;
`

function StyledTableHeader({children}) {
    return (
        <Wrapper>
            {children}
        </Wrapper>
    )
}

export default StyledTableHeader
